import {JobCategory} from './job-category';
import {IVdabSpecific} from './i-vdab-specific';
import {ExternalReference} from './external-reference';
import {ExternalCode} from './external-code';
import {Attribute} from './attribute';

export class VdabSpecific {
	public constructor(public jobCategories: Array<JobCategory>,
					   public externalReferences: Array<ExternalReference>,
					   public externalCodes: Array<ExternalCode>,
					   public attributes: Array<Attribute>,
					   public bottleneckJob: boolean) {
	}

	public static fromInterface(iVdabSpecific: IVdabSpecific): VdabSpecific {
		return new VdabSpecific(
			iVdabSpecific.jobCategories
				.map(jobCategory => JobCategory.fromInterface(jobCategory)),
			iVdabSpecific.externalReferences
				.map(externalReference => ExternalReference.fromInterface(externalReference)),
			iVdabSpecific.externalCodes
				.map(externalCode => ExternalCode.fromInterface(externalCode)),
			iVdabSpecific.attributes
				.map(attribute => Attribute.fromInterface(attribute)),
			iVdabSpecific.bottleneckJob
		);
	}

	public hasAttribute(code: string): boolean {
		return this.attributes.filter(value => code === value.code).length > 0;
	}
}
